import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  ModalFooter,
  Box,
  Text,
  Button,
} from '@chakra-ui/react';

interface CancelSigningModalProps {
  isOpen: boolean;
  onClose: () => void;
  onCancel: () => void;
  isLoading: boolean;
}

const CancelSigningModal = ({
  isOpen,
  onClose,
  onCancel,
  isLoading,
}: CancelSigningModalProps) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="md">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Cancel Signing Request</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Text mb="4">
            Are you sure you want to cancel the signing process?
          </Text>
          <Box
            p="3"
            borderRadius="md"
            bg="orange.50"
            borderLeft="4px solid"
            borderLeftColor="orange.500"
          >
            <Text fontSize="sm" color="orange.700">
              This action will cancel the signing process for all parties
              involved. The documents will no longer be available for signing.
            </Text>
          </Box>
        </ModalBody>
        <ModalFooter>
          <Button variant="ghost" mr="3" onClick={onClose} disabled={isLoading}>
            Keep Signing Active
          </Button>
          <Button
            variant="outline"
            colorScheme="red"
            onClick={onCancel}
            isLoading={isLoading}
            disabled={isLoading}
          >
            Cancel Signing
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default CancelSigningModal;
